import { render, staticRenderFns } from "./AppMailPopup.vue?vue&type=template&id=397df689&"
import script from "./AppMailPopup.vue?vue&type=script&lang=js&"
export * from "./AppMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports